import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "documentpreference"
    }}>{`DocumentPreference`}</h1>
    <p>{`Document preferences.`}</p>
    <h2 {...{
      "id": "instance"
    }}>{`Instance`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`isValid`}</strong>{` `}</p>
      <p parentName="blockquote">{`Returns true if the object specifier resolves to valid objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`parent`}</strong>{` `}</p>
      <p parentName="blockquote">{`The parent of the DocumentPreference (a Application or Document).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Events `}<strong parentName="p">{`events`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of events.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`EventListeners `}<strong parentName="p">{`eventListeners`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of event listeners.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`pageHeight`}</strong>{` `}</p>
      <p parentName="blockquote">{`The height of the page.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`pageWidth`}</strong>{` `}</p>
      <p parentName="blockquote">{`The width of the page.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`PageOrientation `}<strong parentName="p">{`pageOrientation`}</strong>{` `}</p>
      <p parentName="blockquote">{`The page orientation.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`columnGuideColor`}</strong>{` `}</p>
      <p parentName="blockquote">{`The color of the column guides, specified either as an array of three doubles, each in the range 0 to 255 and representing R, G, and B values,, or as a UI color. Can return: Array of 3 Reals (0 - 255) or UIColors enumerator.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`marginGuideColor`}</strong>{` `}</p>
      <p parentName="blockquote">{`The color of the margin guides, specified either as an array of three doubles, each in the range 0 to 255, representing R, G, and B values, or as a UI color. Can return: Array of 3 Reals (0 - 255) or UIColors enumerator.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`createPrimaryTextFrame`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, the document A-master has primary text frames when a new document is created.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`pagesPerDocument`}</strong>{` `}</p>
      <p parentName="blockquote">{`The number of pages in the document. (Range: 1 to 9999)`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`facingPages`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, the document has facing pages.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`documentBleedTopOffset`}</strong>{` `}</p>
      <p parentName="blockquote">{`The amount to offset the top document bleed.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`documentBleedBottomOffset`}</strong>{` `}</p>
      <p parentName="blockquote">{`The amount to offset the bottom document bleed. Note: To set the bleed bottom offset, document bleed uniform size must be false.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`documentBleedInsideOrLeftOffset`}</strong>{` `}</p>
      <p parentName="blockquote">{`The amount to offset the inside or left document bleed. Note: To set the bleed inside or left offset, document bleed uniform size must be false.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`documentBleedOutsideOrRightOffset`}</strong>{` `}</p>
      <p parentName="blockquote">{`The amount to offset the outside or right document bleed. Note: To set the bleed outside or right offset, document bleed uniform size must be false.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`documentBleedUniformSize`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, uses the document bleed top offset value for bleed offset measurements on all sides of the document. The default setting is true.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`slugTopOffset`}</strong>{` `}</p>
      <p parentName="blockquote">{`The amount to offset the top slug.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`slugBottomOffset`}</strong>{` `}</p>
      <p parentName="blockquote">{`The amount to offset the bottom slug. Note: To set the slug bottom offset, document slug uniform size must be false.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`slugInsideOrLeftOffset`}</strong>{` `}</p>
      <p parentName="blockquote">{`The amount to offset the inside or left slug. Note: To set the slug inside or left offset, document slug uniform size must be false.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Measurement Unit (Number or String)=any `}<strong parentName="p">{`slugRightOrOutsideOffset`}</strong>{` `}</p>
      <p parentName="blockquote">{`The amount to offset the outside or right slug. Note: To set the slug right or outside offset, document slug uniform size must be false.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`documentSlugUniformSize`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, uses the slug top offset value for slug measurements on all sides of the document. The default value is false.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`preserveLayoutWhenShuffling`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, preserves the layout of spreads that contained more than two pages when allow page shuffle was turned on. If false, changes multi-page spreads to two-page spreads if the spreads were created or changed since allow page shuffle was turned on.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`allowPageShuffle`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, guarantees that when pages are added to a spread it will contain a maximum of two pages. If false, allows pages to be added or moved into existing spreads. For override information, see preserve layout when shuffling.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`overprintBlack`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, overprints black when saving the document.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`columnGuideLocked`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, locks column guides.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`startPageNumber`}</strong>{` `}</p>
      <p parentName="blockquote">{`The starting page number for a document. This is the same as the starting page number for the first section of a document. Default value is 1.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`DocumentIntentOptions `}<strong parentName="p">{`intent`}</strong>{` `}</p>
      <p parentName="blockquote">{`The intent for a document.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`PageBindingOptions `}<strong parentName="p">{`pageBinding`}</strong>{` `}</p>
      <p parentName="blockquote">{`The placement of the page binding.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`HorizontalOrVertical `}<strong parentName="p">{`columnDirection`}</strong>{` `}</p>
      <p parentName="blockquote">{`The direction of text in the column.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`pageSize`}</strong>{` `}</p>
      <p parentName="blockquote">{`The size of the page.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`snippetImportUsesOriginalLocation`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, causes UI-based snippet import to use original location for page items.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Object `}<strong parentName="p">{`properties`}</strong>{` `}</p>
      <p parentName="blockquote">{`A property that allows setting of several properties at the same time.`}</p>
    </blockquote>
    <h3 {...{
      "id": "methods"
    }}>{`Methods`}</h3>
    <blockquote>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSource`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Generates a string which, if executed, will return the DocumentPreference.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`DocumentPreference `}<strong parentName="p">{`getElements`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Resolves the object specifier, creating an array of object references.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSpecifier`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Retrieves the object specifier.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`EventListener `}<strong parentName="p">{`addEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Adds an event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`removeEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Removes the event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-1"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      